/* eslint-disable */
// This code is autogenerated using @harnessio/oats-cli.
// Please do not modify this code directly.
import type { PaginatedAssetListList } from '../schemas/PaginatedAssetListList';
import { fetcher, FetcherOptions } from './fetcher';

export interface AssetsAssetV2ListAPIQueryParams {
  contents?: string;
  limit?: number;
  locked?: boolean;
  offset?: number;
  ordering?: string;
  /**
   * @format uuid
   */
  organizations?: string;
  projects?: string;
  /**
   * @format uuid
   */
  saved_search?: string;
  search?: string;
  text_asset_type?: 'BLOG' | 'CUSTOM' | 'EMAIL' | 'LINKEDIN' | 'TAKEAWAYS';
  types?: '' | 'CLIP' | 'MULTI_MODAL' | 'TEXT' | null | null;
}

export type AssetsAssetV2ListOkResponse = PaginatedAssetListList;

export type AssetsAssetV2ListErrorResponse = unknown;

export interface AssetsAssetV2ListProps
  extends Omit<
    FetcherOptions<AssetsAssetV2ListAPIQueryParams, unknown>,
    'url'
  > {
  queryParams: AssetsAssetV2ListAPIQueryParams;
}

export function assetsAssetV2List(
  props: AssetsAssetV2ListProps
): Promise<AssetsAssetV2ListOkResponse> {
  return fetcher<
    AssetsAssetV2ListOkResponse,
    AssetsAssetV2ListAPIQueryParams,
    unknown
  >({
    url: `/assets/asset-v2/`,
    method: 'GET',
    ...props
  });
}
